import './creditCard.scss';

import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Icon, { ICON_TYPE } from '../icon';
import { Typography, Anchor, Card } from '../base';

const CreditCard = forwardRef((props, ref) => {
  const className = classNames({
    'card-payment': true,
    [props.className]: props.className,
  });

  const handleOnRemoveClick = e => {
    e.preventDefault();

    props.onRemove(props.id);
  };

  return (
    <Card ref={ref} className={className}>
      <Card.Body>
        <div className="card-payment-header">
          {props.logo && (
            <img className="card-payment-logo" src={`/static/img/${props.logo}`} alt={props.brand} />
          )}
          <Anchor className="card-link-remove" onClick={handleOnRemoveClick}>
            <Icon type={ICON_TYPE.REMOVE} />
          </Anchor>
        </div>
        <Typography.Span className="card-payment-number">{props.number}</Typography.Span>
        <div className="card-payment-footer">
          <div className="card-payment-detail">
            <Typography.Span className="card-payment-label">Card Holder</Typography.Span>
            <Typography.Span className="card-payment-value">{props.name}</Typography.Span>
          </div>
          <div className="card-payment-detail card-payment-detail-right">
            <Typography.Span className="card-payment-label">Valid Thru</Typography.Span>
            <Typography.Span className="card-payment-value">{props.expiration}</Typography.Span>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
});

CreditCard.propTypes = {
  id: PropTypes.number,
  number: PropTypes.string,
  name: PropTypes.string,
  expiration: PropTypes.string,
  brand: PropTypes.string,
  logo: PropTypes.string,
  onRemove: PropTypes.func,
  className: PropTypes.string,
};

export default CreditCard;
